import { apiInstance, apiInstanceUnauthorized } from 'api/utils';

const mpsHub = {
  requestNewProvider: (name: string, message: string) => {
    return apiInstance.request({
      method: 'POST',
      url: '/mps-hub/new-provider-request/',
      data: { name, message }
    });
  },
  contactProvider: (email: string, provider_email: string, message: string) => {
    return apiInstance.request({
      method: 'POST',
      url: '/mps-hub/contact-provider/',
      data: { email, provider_email, message }
    });
  },
  getMpsProviders: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/mps-hub/providers/'
    });
  },
  getMpsProviderAdmins: () => {
    return apiInstanceUnauthorized.request({
      method: 'GET',
      url: '/users/providers/'
    });
  },
  getMpsProvider: (id: number) => {
    return apiInstance.request({
      method: 'GET',
      url: `/mps-hub/providers/${id}/`
    });
  },
  getMpsProvidersFavourites: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/mps-hub/providers/favourites/'
    });
  },
  setMpsProvidersFavourite: (provider: any) => {
    return apiInstance.request({
      method: 'POST',
      url: '/mps-hub/providers/favourites/',
      data: { provider: provider.id }
    });
  },
  removeMpsProvidersFavourite: (provider: any, favouriteId: any) => {
    return apiInstance.request({
      method: 'DELETE',
      url: `/mps-hub/providers/favourites/${favouriteId}/`
    });
  },
  updateMpsProvider: (id: number, data: any) => {
    return apiInstance.request({
      method: 'PATCH',
      url: `/mps-hub/providers/${id}/`,
      data
    });
  },
  updateMpsProviderPlatforms: (id: number, data: any) => {
    return apiInstance.request({
      method: 'POST',
      url: `/mps-hub/providers/${id}/platforms/`,
      data
    });
  },
  createKeyContact: (providerId: number, data: any) => {
    return apiInstance.request({
      method: 'POST',
      url: `/mps-hub/providers/${providerId}/key-contacts/`,
      data
    });
  },
  updateKeyContact: (providerId: number, id: number, data: any) => {
    return apiInstance.request({
      method: 'PATCH',
      url: `/mps-hub/providers/${providerId}/key-contacts/${id}/`,
      data
    });
  },
  deleteKeyContact: (providerId: number, id: number) => {
    return apiInstance.request({
      method: 'DELETE',
      url: `/mps-hub/providers/${providerId}/key-contacts/${id}/`
    });
  },
  createResource: (providerId: number, data: any) => {
    return apiInstance.request({
      method: 'POST',
      url: `/mps-hub/providers/${providerId}/resources/`,
      data
    });
  },
  updateResource: (providerId: number, id: number, data: any) => {
    return apiInstance.request({
      method: 'PATCH',
      url: `/mps-hub/providers/${providerId}/resources/${id}/`,
      data
    });
  },
  deleteResource: (providerId: number, id: number) => {
    return apiInstance.request({
      method: 'DELETE',
      url: `/mps-hub/providers/${providerId}/resources/${id}/`
    });
  },
  createVideo: (providerId: number, data: any) => {
    return apiInstance.request({
      method: 'POST',
      url: `/mps-hub/providers/${providerId}/videos/`,
      data
    });
  },
  updateVideo: (providerId: number, id: number, data: any) => {
    return apiInstance.request({
      method: 'PATCH',
      url: `/mps-hub/providers/${providerId}/videos/${id}/`,
      data
    });
  },
  deleteVideo: (providerId: number, id: number) => {
    return apiInstance.request({
      method: 'DELETE',
      url: `/mps-hub/providers/${providerId}/videos/${id}/`
    });
  },
  createEvent: (providerId: number, data: any) => {
    return apiInstance.request({
      method: 'POST',
      url: `/mps-hub/providers/${providerId}/events/`,
      data
    });
  },
  updateEvent: (providerId: number, id: number, data: any) => {
    return apiInstance.request({
      method: 'PATCH',
      url: `/mps-hub/providers/${providerId}/events/${id}/`,
      data
    });
  },
  deleteEvent: (providerId: number, id: number) => {
    return apiInstance.request({
      method: 'DELETE',
      url: `/mps-hub/providers/${providerId}/events/${id}/`
    });
  },
  createMarketCommentary: (providerId: number, data: any) => {
    return apiInstance.request({
      method: 'POST',
      url: `/mps-hub/providers/${providerId}/market-commentaries/`,
      data
    });
  },
  updateMarketCommentary: (providerId: number, id: number, data: any) => {
    return apiInstance.request({
      method: 'PATCH',
      url: `/mps-hub/providers/${providerId}/market-commentaries/${id}/`,
      data
    });
  },
  deleteMarketCommentary: (providerId: number, id: number) => {
    return apiInstance.request({
      method: 'DELETE',
      url: `/mps-hub/providers/${providerId}/market-commentaries/${id}/`
    });
  },
  createPortfolioRange: (providerId: number, data: any) => {
    return apiInstance.request({
      method: 'POST',
      url: `/mps-hub/providers/${providerId}/portfolio-ranges/`,
      data
    });
  },
  updatePortfolioRange: (providerId: number, id: number, data: any) => {
    return apiInstance.request({
      method: 'PATCH',
      url: `/mps-hub/providers/${providerId}/portfolio-ranges/${id}/`,
      data
    });
  },
  deletePortfolioRange: (providerId: number, id: number) => {
    return apiInstance.request({
      method: 'DELETE',
      url: `/mps-hub/providers/${providerId}/portfolio-ranges/${id}/`
    });
  },
  getPortfolioCategories: () =>
    apiInstance.request({
      method: 'GET',
      url: '/mps-hub/portfolio-categories/'
    }),
  getLegalRelationships: () =>
    apiInstance.request({
      method: 'GET',
      url: '/mps-hub/legal-relationships/'
    }),
  getMpsHubRiskPortfolioResearch: (provider: any, range: number) =>
    apiInstance.request({
      method: 'GET',
      url: `/mps-hub/providers/${provider}/portfolio-ranges/${range}/portfolio-research/`
    }),
  getMpsHubRiskRatings: (provider: any, range: any) =>
    apiInstance.request({
      method: 'GET',
      url: `/mps-hub/providers/${provider}/portfolio-ranges/${range}/risk-ratings/`
    }),
  getMpsHubPastPerformance: ({ provider, range, data }: any) =>
    apiInstance.request({
      method: 'POST',
      url: `/mps-hub/providers/${provider}/portfolio-ranges/${range}/past-performance/`,
      data
    })
};

export default {
  ...mpsHub
};
